export default function initTabbedCarouselControls(){

    const tabbedControls = document.querySelectorAll('.tabbed-carousel-controls, .tabbed-resource-carousel-controls');
    tabbedControls.forEach( controls => {
       
        const tabbedNav = controls.querySelector('.tabbed-nav-tabs');
        
        const handleScroll = (e) => {
            if (tabbedNav.scrollLeft < 5 && tabbedNav.offsetWidth <= tabbedNav.scrollWidth) {
                tabbedNav.classList.remove('is-scrolled');
                tabbedNav.classList.remove('is-scroll-complete');
                return false;
            }


            if (tabbedNav.scrollLeft > 5) {
                tabbedNav.classList.add('is-scrolled');
            } else {
                tabbedNav.classList.remove('is-scrolled');
            }

            if (tabbedNav.scrollLeft + tabbedNav.offsetWidth >= tabbedNav.scrollWidth) {
                tabbedNav.classList.add('is-scroll-complete');
            } else {
                tabbedNav.classList.remove('is-scroll-complete');
            }
        }
        tabbedNav.addEventListener('scroll', (e) => {    
            handleScroll(e);
        });

        window.addEventListener('resize', (e) => {
            handleScroll(e);
        });
	});

}
